import { render, staticRenderFns } from "./jupyterhub.vue?vue&type=template&id=72b29632&scoped=true&"
import script from "./jupyterhub.vue?vue&type=script&lang=js&"
export * from "./jupyterhub.vue?vue&type=script&lang=js&"
import style0 from "./jupyterhub.vue?vue&type=style&index=0&id=72b29632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b29632",
  null
  
)

export default component.exports